export default "__VITE_ASSET__uOJLWHG2__"